import commonGetters from '@/store/data/common/getters'
import { find, isNil, toNumber, pick } from 'lodash'

const getters = {
    getDspLabel: (_state, _getters, rootState) => params => {
        const dsp = find(rootState.data.dsp.list, dsp => dsp.id === toNumber(params.dspId))
        return !isNil(dsp) ? dsp.label : 'Pixel URL'
    },

    getAccountDspLabel: (_state, _getters, rootState) => params => {
        const accountDsp = find(rootState.data.accountsDsps.list, accountDsp => accountDsp.id === params.accountsDspId)
        return !isNil(accountDsp) ? accountDsp.transferLabel : '-'
    },

    getAudienceLabel: (_state, _getters, rootState) => params => {
        const audience = find(rootState.data.audience.list, audience => +audience.id === +params.audience_id)
        return !isNil(audience) ? audience.label : 'N/A'
    },
    getAudienceInfos: (_state, _getters, rootState) => params => {
        const audience = find(rootState.data.audience.list, audience => +audience.id === +params.audience_id)
        return audience
    },
    transfersActiveError: state => state.transfersActiveError,

    /*
    // PREVIOUS DISPLAYED TRANSFER LABEL
    getLabel: (state, getters, rootState, rootGetters) => params => {
        if (params.pixelUrl === '') {
            let dspLabel = isNil(params.dspId) ? 'N/A' : getters.getDspLabel({ dspId: params.dspId })
            let accountsDspLabel = isNil(params.accountsDspId) ? 'N/A' : getters.getAccountDspLabel({ accountsDspId: params.accountsDspId })
            return dspLabel + ' - ' + accountsDspLabel
        }
        return 'pixel'
    },
    */

    getTransfersByAudienceList: state => params => {
        const audienceIds = []
        for (const audience of params.audienceList) {
            audienceIds.push(audience.id)
        }
        return pick(state.list, audienceIds)
    }
}

export default { ...commonGetters, ...getters }
